/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import DeviceForm from './DeviceForm';
import { editDevice } from '../../../../../../services/device/Device';
import { getAllDevice } from '../../../../../../store/reducers/device/deviceAction';

const DeviceEdit = ({ handleClose, selectedDevice }) => {

    const dispatch = useDispatch(); 
    const handleSubmit = async ({ deviceName, deviceOwnerID, detailName, detailValue }, { setSubmitting }) => {
        setSubmitting(true);

        try{
            await editDevice({
                deviceName, deviceOwnerID, deviceID: selectedDevice.deviceID, deviceDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Device was edited successfully');
            handleClose();
            await dispatch(getAllDevice()).unwrap();
            setSubmitting(false)

        }catch(error){
            setSubmitting(false)
            toast.error(error?.response?.data?.error?.message);
        } 
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Device  Edit</Typography>
            <Formik
                initialValues={{
                    deviceName: selectedDevice.deviceName,
                    detailName: selectedDevice.deviceDetails[0].detailName,
                    detailValue: selectedDevice.deviceDetails[0].detailValue,
                    deviceOwnerID: selectedDevice.deviceOwnerID
                }}
                validationSchema={Yup.object().shape({
                    deviceName: Yup.string().min(2).max(40).required('Device Name is required.'),
                    deviceOwnerID: Yup.string().required('Owner is required.')
                })}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <DeviceForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}

 
export default DeviceEdit;
